import React, { Component } from 'react';
import Form from 'react-bootstrap/Form'
import Button from 'react-bootstrap/Button'
import ImageUploader from 'react-images-upload';
import StarRatings from 'react-star-ratings';
import { db, auth } from "../Services/firebase";
import { Image, Container, Row } from 'react-bootstrap';
import DisplayStars from '../Utils/DisplayStars';



class Rate extends Component {
  constructor(props) {
    super(props);
    this.changeRating = this.changeRating.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);


    this.state = {
      reviews: [],
      companyId: "",
      companyName: "",
      // uid: auth().currentUser.uid,
      // userName: auth().currentUser.displayName,bd me uncomment krna ha
      uid: "",
      userName: "",
      title: "",
      description: "",
      pictures: [],
      rating: 0,
    };

    this.onDrop = this.onDrop.bind(this);
  }

  onDrop(picture) {
    this.setState({
      pictures: this.state.pictures.concat(picture),
    });
  }

  async componentDidMount() {
    // console.log("yesssssssssssssssss" +JSON.stringify(this.props.location.state.companyName));
    const limit = 12;
    const companyId = this.props.match.params.companyId;

    if (companyId != null) {
      this.setState({
        companyId: companyId,
        companyName: this.props.location.state.companyName

      });
    }
    try {
      db.ref("reviews").orderByChild("companyId").equalTo(companyId).limitToLast(limit).on("value", snapshot => {
        let reviews = [];
        snapshot.forEach((snap) => {
          reviews.push(snap.val());
        });
        this.setState({
          reviews: reviews
        });
       
      });
    } catch (error) {
      console.log(error);
    }

  }

  changeRating(newRating) {
    this.setState({
      rating: newRating
    });
  }

  writeUserData = () => {
    db.ref('/reviews').push({
      title: this.state.title,
      description: this.state.description,
      uid: this.state.uid,
      user: this.state.userName,
      rating: this.state.rating,
      timestamp: Date.now(),
      companyId: this.state.companyId
    });
  }

  handleSubmit = (event) => {
    event.preventDefault();
    this.writeUserData();

  }

  handleChange(event) {
    this.setState({
      [event.target.name]: event.target.value
    });
  }

  render() {


    return (
      <div className="container margin-top-100 mb-5" >

        <div className="signInDiv ">
          <Form className="result-container rating-container">
            <h3 className='bold-semifont blackColor mt-2 text-center'>{this.state.companyName}</h3>
            <Form.Group controlId="formRateNumber">
              <Form.Label className='light-font para mt-2 bold-semifont '>Click and rate your experience*</Form.Label>
              <Form.Group controlId="formRating" className="text-center">
                <StarRatings
                  rating={this.state.rating}
                  starRatedColor="orange"
                  starEmptyColor="grey"
                  starHoverColor='orange'
                  changeRating={this.changeRating}
                  numberOfStars={5}
                  isSelectable='true'
                />

              </Form.Group>
            </Form.Group>
            <Form.Group controlId="formRateTitle">
              <Form.Label className='light-font para mt-2 bold-semifont '>Review Title*</Form.Label>
              <Form.Control as="textarea" name="title" onChange={this.handleChange} rows="1" placeholder="Example: what a nice surprise!" value={this.state.title} />
            </Form.Group>

            <Form.Group controlId="formRateDescription">
              <Form.Label className='light-font para mt-2 bold-semifont '>Describe your experience*</Form.Label>
              <Form.Control as="textarea" name="description" onChange={this.handleChange} rows="4" placeholder="Give accurate information, state the facts and use neutral language." value={this.state.description} />
            </Form.Group>

            <Form.Group controlId="formImages">
              <Form.Label className='light-font para mt-2 bold-semifont'>Would you like to add photos?</Form.Label>
              <ImageUploader
                ref="images"
                withIcon={false}
                buttonText='Upload photo'
                onChange={this.onDrop}
                imgExtension={['.jpg', '.gif', '.png']}
                maxFileSize={5242880}
                withPreview={true}
                buttonClassName="round-button width-200"
                singleImage={true}
              />
              {/* <small className='light-font'>Images need to be audited prior to display</small> */}
            </Form.Group>
            <div className="form-group text-center">
              <Button className='round-button bgPrimary myRiviewButton' type="submit" onClick={this.handleSubmit}>
                Submit your review
              </Button>
            </div>
          </Form>

        </div>

        {/* <Container className="company-ratings">
          <Form.Label className='bold-font para mt-2'>Company Reviews</Form.Label>
          <Row>
            {this.state.reviews && this.state.reviews.map(item => (
              <div key={item._id} className="col-sm-12 col-md-4 col-lg-3">
                <div className="ih-item square effect6 top_to_bottom">
                  <div className="card text-white bg-primary mb-3">
                    <div className="card-header">
                      <StarRatings
                        rating={item.rating}
                        starRatedColor="orange"
                        starEmptyColor="grey"
                        starHoverColor='orange'
                        numberOfStars={5}
                        starDimension='30px'
                        starSpacing='0'
                      />
                    </div>
                    <div className="card-body">
                      <h4 className="card-title">{item.title}</h4>
                      <p className="card-text"><b>{item.user}: </b>{item.description}</p>
                    </div>

                  </div>
                </div>
              </div>
            ))}
          </Row>
        </Container> */}

      </div>
    );
  }
}

export default Rate;
